import { AxiosPromise } from 'axios'

import api from '@config/api'

export function session(token: string): AxiosPromise {
  return api.post('v1/Auth/Login', {
    token
  })
}

export function refresh(token: string, refreshToken: string): AxiosPromise {
  return api.post('v1/Auth/RefreshToken', {
    token,
    refreshToken
  })
}

export function validateToken(): AxiosPromise {
  return api.get('v1/Auth/ValidateToken')
}

export function getUserPopulateData(): AxiosPromise {
  return api.get('v1/Auth/auth0/app_metadata')
}

export default {
  session,
  validateToken,
  refresh,
  getUserPopulateData
}
